import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { AzureMonitoringService } from '../services/AzureMonitoringService';
import * as fromRoot from '../store';
import { NotificationService } from 'app/core/services/notification.service';
import { HttpErrorResponse } from '@angular/common/http';
import { isHttpErrorResponse } from 'app/core/util/util';
import { ErrorMessage, isErrorMessage } from 'app/core/util/error.interface';
import { inject } from '@angular/core';

export abstract class AbstractSandbox {

  protected store: Store<fromRoot.RootState> = inject(Store);
  protected translateService = inject(TranslateService);
  protected azureMonitoringService = inject(AzureMonitoringService);
  protected notificationService = inject(NotificationService);


  protected async handleFail(error: HttpErrorResponse | ErrorMessage | {messageCode: string, translationParams?: string}, titleKey: string = ''): Promise<void> {
    let disableClose = false;
    let message = '';
    let subMessages = [];
    let verbose = null;
    if (isHttpErrorResponse(error)) {
      if (error.error instanceof Blob) {
        try {
          const body = await error.error.text();
          const b = JSON.parse(body);
          if (b.Message) {
            message = b.Message;
            subMessages = b.SubMessages;
          }
        } catch (e) {
          // continue
        }
      }
      if (error.status === 406) {
        disableClose = true;
        message = this.translateService.instant('ERRORS.AUTHORIZATION.ANOTHER_SESSION_WITH_DIFFERENT_CUSTOMER_OPENED');
      } else if (!message) {
        message = error.error?.Message || error.message;
        subMessages = error.error?.SubMessages || [];
      }
      verbose = error.error;
      this.azureMonitoringService?.logException(error.error);
    } else if (isErrorMessage(error)) {
      message = error.message;
      subMessages = error.subMessages;
      this.azureMonitoringService?.logException(error.errorResponse || new Error(message));
      verbose = error.errorResponse.error;
    } else {
      message = this.translateService.instant(error.messageCode, error.translationParams);
    }

    // Customer 'RE.2000016' belonging to Sales Organisation 'NL10' is not available for user 'a71da0d2-883e-46a3-8871-923d55896381'.

    this.notificationService.showModal({
      type: 'error',
      message,
      subMessages,
      verbose,
      title: (titleKey && this.translateService.instant(titleKey)) || '',
      disableClose,
    });
  }
}
